var angular=window.angular,ngModule;
try {ngModule=angular.module(["ng"])}
catch(e){ngModule=angular.module("ng",[])}
var v1="<div class=\"cluster-snapshots\">\n<div class=\"row\">\n<div class=\"col-md-12\">\n<eshq-cluster-navigation></eshq-cluster-navigation>\n</div>\n</div>\n<div class=\"row\">\n<div class=\"col-md-12\" ng-if=\"!!clusterSnapshotsCtrl.fetchingRepositories\">\n<div class=\"summary-loader\">\n<div>\nLoading Repositories <i class=\"fa fa-spinner fa-pulse fa-2x fa-fw\"></i>\n<span class=\"sr-only\">Loading...</span>\n</div>\n</div>\n</div>\n</div>\n<div class=\"divider-3\"></div>\n<eshq-repositories-table ng-if=\"!clusterSnapshotsCtrl.fetchingRepositories\" repositories=\"clusterSnapshotsCtrl.repositories\"></eshq-repositories-table>\n</div>";
var id1="containers/cluster-snapshots/cluster-snapshots.view.html";
var inj=angular.element(window.document).injector();
if(inj){inj.get("$templateCache").put(id1,v1);}
else{ngModule.run(["$templateCache",function(c){c.put(id1,v1)}]);}
module.exports=v1;


//////////////////
// WEBPACK FOOTER
// ./ui/src/containers/cluster-snapshots/cluster-snapshots.view.html
// module id = 800
// module chunks = 0